export class CentroCusto {
  constructor({ id, codigo, nome, unidade, dataCriacao }) {
    this.id = id;
    this.codigo = codigo;
    this.nome = nome;
    this.unidade = unidade;
    this.dataCriacao = dataCriacao;
  }
}
